import { hideAlertMessageOnFocus, SendFormData } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {
    const saveAccountDetailsForms = document.querySelectorAll('.js-save-account-details');

    if (saveAccountDetailsForms.length) {
        saveAccountDetailsForms.forEach(form => {
            //Phone number mask
            let iti;

            const inputNumber = form.querySelector("#phone_number");

            if (inputNumber) {
                iti = window.intlTelInput(inputNumber, {
                    initialCountry: 'lu',
                    preferredCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
                        "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
                        "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
                        "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
                    separateDialCode: true,
                    autoPlaceholder: "off",
                    utilsScript: theme.themeUrl + "/build/vendor/js/intlTelInputUtils.js",
                });
            }

            form.addEventListener('submit', e => {
                e.preventDefault();

                const formWrapper = form.closest('.wcl-modal-inner');
                const emailVerify = form.querySelector('.wcl-email-verify');

                // Get user ID
                const userId = form.dataset.userId;

                // Get UI element
                const messageBlock = form.querySelector('.wcl-message-alert');
                const message = form.querySelector('.wcl-message');

                messageBlock.classList.remove('show', 'error', 'success');

                formWrapper.classList.add('loading');

                let formData = new FormData(form);

                // Get all checkboxes in the form
                let checkboxes = form.querySelectorAll('input[type="checkbox"]');

                checkboxes.forEach(function (checkbox) {
                    // If the checkbox is not checked, add it to the FormData manually
                    if (!checkbox.checked) {
                        formData.append(checkbox.name, '0');
                    }
                });

                // Adding additional data to the array
                formData.append('user_id', userId);


                //Get full phone number
                if (inputNumber) {
                    const number = iti.getNumber();

                    formData.append('phone_number', number);
                }

                SendFormData('account_details', formData).then(function (res) {
                    formWrapper.classList.remove('loading');

                    let response = JSON.parse(res);

                    if (response.success == '1') {
                        if ('email_verified' in response && response.email_verified === 0) {
                            // Show email verify label
                            emailVerify?.classList.add('active');
                        }
                    } else {
                        throw response.message;
                    }

                }).catch(function (err) {
                    // Error
                    formWrapper.classList.remove('loading');

                    messageBlock.classList.add('show', 'error');
                    message.innerHTML = err;

                    hideAlertMessageOnFocus(form, messageBlock);
                });

            })
        });
    }
});